/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * The theme's collapsible sections (Details, Shipping, etc.) only size their
 * content when the toggle button is clicked — a button rendered with
 * aria-expanded="true" server-side (e.g. Details open by default) stays
 * visually collapsed at height:0 until then. This gives already-expanded
 * ones their height up front, matching what a click would have set.
 */
(function () {
  document.querySelectorAll('.Collapsible__Button[aria-expanded="true"]').forEach(function (button) {
    var inner = button.nextElementSibling;
    if (inner && inner.classList.contains('Collapsible__Inner')) {
      inner.style.height = inner.scrollHeight + 'px';
    }
  });
})();

(function () {
  var bar = document.getElementById('StickyAtc');
  if (!bar) return; // not a product page

  // Some apps (preorder/inventory widgets) re-render the product form after load,
  // so the real form/button/options are looked up live instead of cached once.
  function getForm() {
    return document.querySelector('.ProductForm');
  }

  function getRealCta() {
    var form = getForm();
    return form && form.querySelector('.ProductForm__AddToCart');
  }

  function getOptionDivs() {
    var form = getForm();
    return form ? Array.prototype.slice.call(form.querySelectorAll('.ProductForm__Option')) : [];
  }

  function getPriceEl() {
    return document.querySelector('.ProductMeta__Price.Price--highlight') || document.querySelector('.ProductMeta__Price');
  }

  var footer = document.querySelector('.Footer');

  var cta = document.getElementById('StickyAtcCta');
  var ctaLabel = cta.querySelector('.StickyAtc__CtaLabel');
  var ctaPrice = cta.querySelector('.StickyAtc__CtaPrice');
  var selectButtons = Array.prototype.slice.call(bar.querySelectorAll('.StickyAtc__Select'));

  var backdrop = document.getElementById('StickyAtcBackdrop');
  var panel = document.getElementById('StickyAtcPanel');
  var panelContent = document.getElementById('StickyAtcPanelContent');
  var openOptionIndex = null;

  if (!getForm()) return;

  /* --- Keep the sticky bar in sync with the real form --- */

  function syncCta() {
    var realCta = getRealCta();
    if (!realCta) return;

    var isSoldOut = realCta.disabled;
    cta.disabled = isSoldOut;
    cta.classList.toggle('is-ready', !isSoldOut);
    ctaLabel.textContent = realCta.querySelector('span') ? realCta.querySelector('span').textContent : realCta.textContent;

    var priceEl = getPriceEl();
    if (priceEl) {
      ctaPrice.textContent = priceEl.textContent.trim();
    }
  }

  function syncSelectors() {
    var optionDivs = getOptionDivs();

    selectButtons.forEach(function (button) {
      var index = parseInt(button.getAttribute('data-option-index'), 10);
      var optionDiv = optionDivs[index];
      if (!optionDiv) return;

      var checkedInput = optionDiv.querySelector('input:checked');
      if (checkedInput) {
        button.querySelector('.StickyAtc__SelectValue').textContent = checkedInput.value;
      }
    });
  }

  function sync() {
    syncCta();
    syncSelectors();
  }

  document.addEventListener('variant:changed', sync);

  /* --- Bottom sheet: pick a value, drive the real (hidden) input --- */

  function closePanel() {
    panel.classList.remove('is-active');
    // The open panel is anchored above the sticky bar via an inline bottom offset.
    // That offset must be cleared on close: the closed state hides the panel by
    // sliding it down by its own height, so with the offset still applied the top
    // of the panel would keep peeking into the viewport.
    panel.style.bottom = '';
    backdrop.classList.remove('is-active');
    selectButtons.forEach(function (button) { button.classList.remove('is-open'); });
    openOptionIndex = null;
  }

  function openPanel(index, triggerButton) {
    if (openOptionIndex === index) {
      closePanel();
      return;
    }

    var optionDiv = getOptionDivs()[index];
    if (!optionDiv) return;

    var swatchList = optionDiv.querySelector('.ColorSwatchList, .SizeSwatchList');
    if (!swatchList) return;

    panelContent.innerHTML = '';

    Array.prototype.forEach.call(swatchList.querySelectorAll('label'), function (realLabel) {
      var clone = realLabel.cloneNode(true);
      clone.removeAttribute('for');

      if (realLabel.previousElementSibling && realLabel.previousElementSibling.checked) {
        clone.classList.add('is-selected');
      }

      clone.addEventListener('click', function () {
        var realInput = realLabel.previousElementSibling;
        if (!realInput) return;

        realInput.checked = true;
        realInput.dispatchEvent(new Event('change', { bubbles: true }));

        setTimeout(function () {
          sync();
          closePanel();
        }, 50);
      });

      panelContent.appendChild(clone);
    });

    panel.style.bottom = bar.offsetHeight + 'px';
    panel.classList.add('is-active');
    backdrop.classList.add('is-active');

    selectButtons.forEach(function (button) { button.classList.toggle('is-open', button === triggerButton); });
    openOptionIndex = index;
  }

  selectButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      openPanel(parseInt(button.getAttribute('data-option-index'), 10), button);
    });
  });

  backdrop.addEventListener('click', closePanel);

  cta.addEventListener('click', function () {
    var realCta = getRealCta();
    if (!cta.disabled && realCta) realCta.click();
  });

  /* --- Visibility: show before the real button is reached and after it's
     scrolled past, hide while it's on screen or once the footer shows up --- */

  var mobileQuery = window.matchMedia('(max-width: 1007px)');
  var isTicking = false;
  var lastShouldShow = null;

  function isCartDrawerOpen() {
    var drawer = document.getElementById('sidebar-cart');
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  function updateVisibility() {
    isTicking = false;

    if (!mobileQuery.matches || isCartDrawerOpen()) {
      if (lastShouldShow !== false) {
        bar.classList.add('is-hidden');
        closePanel();
        lastShouldShow = false;
      }
      return;
    }

    var realCta = getRealCta();
    if (!realCta) return;

    var rect = realCta.getBoundingClientRect();
    var windowHeight = window.innerHeight;

    var isBefore = rect.top > windowHeight;
    var isAfter = rect.bottom < 0;

    var footerVisible = false;
    if (footer) {
      var footerRect = footer.getBoundingClientRect();
      footerVisible = footerRect.top < (windowHeight - 50);
    }

    var shouldShow = (isBefore || isAfter) && !footerVisible;

    if (shouldShow !== lastShouldShow) {
      bar.classList.toggle('is-hidden', !shouldShow);
      if (!shouldShow) closePanel();
      lastShouldShow = shouldShow;
    }
  }

  function onScroll() {
    if (!isTicking) {
      isTicking = true;
      window.requestAnimationFrame(updateVisibility);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  var cartDrawer = document.getElementById('sidebar-cart');
  if (cartDrawer) {
    new MutationObserver(onScroll).observe(cartDrawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  sync();
  onScroll();
})();

/**
 * Cart drawer: "You may also like" recommendations.
 *
 * Cards are fetched pre-rendered from the Section Rendering API
 * (sections/cart-recommendations-items.liquid), seeded by the most recently
 * added product (tracked via the theme's own 'product:added' hook). Server
 * rendering keeps prices on Liquid money filters, so Shopify Markets price
 * lists and price rounding apply — never convert prices client-side here.
 * The section also skips products already in the cart.
 */
(function () {
  var LAST_ADDED_KEY = 'lastAddedProductId';

  document.addEventListener('product:added', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.product_id) {
      try { sessionStorage.setItem(LAST_ADDED_KEY, variant.product_id); } catch (e) {}
    }

    setTimeout(loadCartRecommendations, 300);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')) {
      loadCartRecommendations();
    }

    var toggle = event.target.closest('[data-action="toggle-cart-recommendations"]');
    if (toggle) {
      var container = toggle.closest('.CartRecommendations');
      var collapsed = container.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', String(!collapsed));
    }

    var addButton = event.target.closest('.CartRecommendation__Add');
    if (addButton && !addButton.disabled) {
      event.preventDefault();
      addRecommendationToCart(addButton);
    }
  });

  /**
   * Storefront route root including the market/locale subfolder (e.g. "/fr-fr/").
   * Root-relative fetches would silently leave the shopper's market and come
   * back in the wrong language/currency context.
   */
  function routeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) {
      var match = window.location.pathname.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i);
      root = match ? match[0] + '/' : '/';
    }
    return root;
  }

  function fetchRecommendations(seedId, intent) {
    var url = routeRoot() + 'recommendations/products?section_id=cart-recommendations-items' +
      '&product_id=' + seedId + '&limit=8&intent=' + intent;

    return fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.CartRecommendation'));
      });
  }

  function loadCartRecommendations() {
    var container = document.getElementById('CartRecommendations');
    if (!container) return;

    var seedId = 0;
    try { seedId = parseInt(sessionStorage.getItem(LAST_ADDED_KEY), 10) || 0; } catch (e) {}
    if (!seedId) seedId = parseInt(container.getAttribute('data-fallback-product-id'), 10) || 0;
    if (!seedId) return;

    fetchRecommendations(seedId, 'complementary')
      .then(function (cards) {
        if (cards.length) return cards;
        return fetchRecommendations(seedId, 'related');
      })
      .then(function (cards) {
        renderRecommendations(container, cards);
      })
      .catch(function () {});
  }

  function renderRecommendations(container, cards) {
    var list = container.querySelector('[data-recommendations-list]');
    if (!list) return;

    if (!cards.length) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    list.innerHTML = '';

    cards.forEach(function (card) {
      list.appendChild(card);
    });
  }

  function addRecommendationToCart(button) {
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: button.getAttribute('data-variant-id'), quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) return Promise.reject();
        return response.json();
      })
      .then(function (item) {
        try { sessionStorage.setItem(LAST_ADDED_KEY, item.product_id); } catch (e) {}
        document.dispatchEvent(new CustomEvent('product:added', { detail: { variant: item, quantity: 1 } }));

        return refreshCartDrawer();
      })
      .then(function () {
        loadCartRecommendations();
      })
      .catch(function () {
        button.disabled = false;
      });
  }

  function refreshCartDrawer() {
    return fetch(routeRoot() + 'cart?view=drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var freshDrawer = new DOMParser().parseFromString(html, 'text/html').getElementById('sidebar-cart');
        var currentDrawer = document.getElementById('sidebar-cart');
        if (freshDrawer && currentDrawer) {
          currentDrawer.innerHTML = freshDrawer.innerHTML;
        }
      });
  }
})();

/**
 * Instagram feed: defer offscreen images.
 *
 * The feed lives near the bottom of the home page but its images are injected at
 * runtime by a third-party app, straight from Instagram's CDN and at full
 * resolution (single images have measured over 1MB). Because the app writes the
 * <img> tags itself we can't set the attributes in Liquid, so they're marked
 * lazy/async as they arrive — the bytes are then only fetched if a visitor
 * actually scrolls down to the feed.
 */
(function () {
  var feed = document.getElementById('insta-feed');
  if (!feed || !('MutationObserver' in window)) return;

  function defer(root) {
    var images = root.tagName === 'IMG' ? [root] : root.querySelectorAll ? root.querySelectorAll('img') : [];

    Array.prototype.forEach.call(images, function (img) {
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }

  defer(feed);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) defer(node);
      });
    });
  }).observe(feed, { childList: true, subtree: true });
})();